<div #mainDiv_ll_info_request_spreadsheet_mapping>

  <div *ngIf="bundle.showThis; then MAPPING; else BLANK"></div>

  <ng-template #BLANK></ng-template>

  <ng-template #MAPPING>

    <div [style.top.px]="10"
         [style.left.px]="0"
         [style.width.px]="bundle.objW"
         [style.height.px]="bundle.objH"
         style="position: absolute;z-index:100;background-color: white;border: 1px solid gray;">

      <div *ngIf="bundle.showDG"
           [style.top.px]="bundle.gridY"
           [style.left.px]="bundle.gridX"
           style="position: absolute;">


        <!-- Grid Wrapper (below the new divs) -->
        <div class="grid-wrapper">
          <!-- First Grid (Source) -->
          <div class="grid-container" [style.width.px]="bundle.gridW" [style.height.px]="bundle.gridH">
            <table id="sourceGrid">
              <tr>
                <!-- Header for row number column (non-resizable) -->
                <th [style.width.px]="bundle.sourceColumnWidths[0]"></th>
                <th *ngFor="let header of bundle.sourceHeaders; let i = index" [style.width.px]="bundle.sourceColumnWidths[i + 1]">
                  {{ header }}
                  <div class="resize-handle" (mousedown)="startResize($event, i + 1, 'source', false)"></div>
                </th>
              </tr>
              <tr *ngFor="let row of bundle.sourceData; let rowIndex = index">
                <!-- Row number column (non-draggable, non-resizable) -->
                <td [ngClass]="{'source-cell': true, 'row-number': true}"
                    [style.width.px]="bundle.sourceColumnWidths[0]"
                    [style.backgroundColor]="'#F2F2F2'"
                    [style.fontWeight]="'bold'"
                    [style.fontSize.px]="12"
                    (mouseover)="highlightSourceCell($event)"
                    (mouseout)="unhighlightSourceCell($event)">
                  {{ row.ROWNUMBER }}
                </td>
                <!-- Data columns (all draggable and resizable) -->
                <td *ngFor="let header of bundle.sourceHeaders; let colIndex = index"
                    [ngClass]="{'source-cell': true}"
                    [attr.draggable]="'true'"
                    (click)="toggleColor($event)"
                    (mouseover)="highlightSourceCell($event)"
                    (mouseout)="unhighlightSourceCell($event)"
                    (mousedown)="startDrag($event, row[header], row.ROWNUMBER - 1, colIndex + 1)"
                    [style.width.px]="bundle.sourceColumnWidths[colIndex + 1]"
                    [style.backgroundColor]="bundle.sourceCellColors[row.ROWNUMBER - 1]?.[colIndex + 1] || '#FFFFFF'">
                  {{ row[header] }}
                </td>
              </tr>
            </table>
          </div>

         
          <!-- Second Grid (Target) -->
          <div class="grid-container" [style.width.px]="bundle.targetGridWidth" [style.height.px]="bundle.gridH">
            <table id="targetGrid">
              <tr>
                <th [style.width.px]="bundle.questionNameW">
                  Target Value
                  <div class="resize-handle" (mousedown)="startResize($event, 0, 'target', false)"></div>
                </th>
                <th [style.width.px]="bundle.targetColumnWidths[1]">
                  Result
                  <div class="resize-handle" (mousedown)="startResize($event, 1, 'target', false)"></div>
                </th>
                <th [style.width.px]="100" style="text-align: center;" >
                  
                </th>
              </tr>
              <tr *ngFor="let row of bundle.targetData; let rowIndex = index">
                <td (click)="toggleColor($event)"
                    (mouseover)="highlightCell($event)"
                    (mouseout)="unhighlightCell($event)"
                    [style.width.px]="bundle.questionNameW">
                  {{ row.QUESTIONNAME }}
                </td>
                <td (click)="toggleColor($event)"
                    (mouseover)="highlightCell($event)"
                    (mouseout)="unhighlightCell($event)"
                    (dragover)="highlightTargetRow($event, rowIndex)"
                    (dragleave)="unhighlightTargetRow($event, rowIndex)"
                    (drop)="drop($event, rowIndex)"
                    [style.width.px]="bundle.targetColumnWidths[1]"
                    [style.backgroundColor]="row.BACKGROUNDCOLOR"
                    style="text-align: right;">
                  {{ row.QUESTIONRESULT_USER }}
                </td>
                <td [style.width.px]="80" style="text-align: center;">
                  <div class="wordBtn_12" (click)="removeMap(rowIndex)" style="cursor: pointer; display: inline-block;">
                    Remove
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>

      </div>

      <div [style.top.px]="10"
           [style.left.px]="bundle.gridX"
           style="position: absolute;">

        <div class="wordBtnGroup" style="padding-left:0px; padding-top:0px;">
          <img class="btnIcon" height=23 style="width: auto;" src="assets/icon_backArrow.png" alt="" (click)="goBack()">
          <div class="wordBtn14" style="padding-left:5px; padding-top:3px;" (click)="goBack()">Go Back</div>
        </div>

        <!-- Select a Spreadsheet with Info Button and Tooltip -->
        <div [style.width.px]="100" style="float: left; padding-left: 20px; white-space: normal;">
          <div class="txtNorm" style="padding-top: 5px; white-space: normal;">
            Select a Spreadsheet:
          </div>

        </div>

        <!--Tooltip_01-->
        <div style="float: left; padding-left: 0px;">
          <img height="10"
               style="float: left; padding-left: 0px; padding-top: -5px; width: auto; cursor: pointer; "
               src="assets/infoBtn.png"
               (mouseenter)="showTooltip_01 = true"
               (mouseleave)="showTooltip_01 = false">

          <div *ngIf="showTooltip_01"
               [style.left.px]="bundle.gridX + 190"
               style="position: absolute; top: 0; width: 200px; padding: 5px; background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; z-index: 1000;">
            Upload the spreadsheets containing Target Values in the data entry form you were just in.  Select the “Go Back” button in the upper left of the view to return to that form.   Select/click a spreadsheet in the box to the right that contains target values listed on the right of the screen. Click and hold down on cells in the selected spreadsheet containing target values and drag then drop (let go) in the corresponding ‘Result’ cells in the target value list.  Select subsequent spreadsheets containing different target values and repeat.  When selecting new sheets, expect the values and colors to clear.  Only the values with the selected spreadsheet will be displayed.  If the spreadsheets are standard reports, that is the same in future forms, this application will recognize them when they are selected and auto-load its values for your confirmation.
          </div>

        </div>

        <!--Upload new spreadsheet--->
        <div *ngIf="bundle.canUpload" class="upload-btn-wrapper" style="cursor: pointer; float: left; padding-right: 5px; padding-left: 0px; padding-top: 0px; ">

          <button class="btn" style="padding-left: 10px;">
            <img id=btmImage height=20 style=" width:auto; float:left;" src="assets/icon_upload.png" alt="">
          </button>

          <input type="file" (change)="fileUpload($event)" accept={{bundle.acceptedExts}}>

          <div class="wordBtn" style="float: unset; width: 50px; text-align: center; line-height: 1.2; padding-top: 0px; white-space: normal; ">
            Upload New
          </div>

        </div>

        <!-- Scroll box for filenames (assumed context) -->
        <div [style.width.px]="bundle.spW" [style.height.px]="bundle.spH" style="float: left; margin-left: 5px; overflow-y: auto; border: 1px solid #ccc;" #scrollBox>
          <div *ngFor="let doc of bundle.documents.slice(0, bundle.documents.length); let i = index"
               class="wordBtn_12"
               [ngClass]="{'selected-row': i === bundle.docIndex}"
               (click)="selectDocument({args: {index: i}})"
               [style.width.px]="bundle.spW - 20"
               [attr.data-index]="i"
               style="display: block; padding: 2px 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            {{doc.FILENAME}}
          </div>
        </div>

        <!-- Arrows -->
        <div style="float: left; padding-left: 3px; padding-top: 5px;">
          <img class="icon" height="20"
               style="display: block; width: auto; cursor: pointer;"
               src="assets/icon_arrowUp.png"
               (click)="docChange('UP')">
          <img class="icon" height="20"
               style="display: block; width: auto; cursor: pointer; margin-top: 10px;"
               src="assets/icon_arrowDown.png"
               (click)="docChange('DOWN')">
        </div>

        <!--Tooltip_02-->
        <div style="float: left; padding-left: 3px; padding-top: -5px; ">
          <img height="10"
               style="float: left; cursor: pointer;"
               src="assets/infoBtn.png"
               (mouseenter)="showTooltip_02 = true"
               (mouseleave)="showTooltip_02 = false">
          <!-- Tooltip -->
          <div *ngIf="showTooltip_02"
               [style.left.px]="bundle.gridX + bundle.gridW - 170"
               style="position: absolute; top: 0; right: -220px; width: 200px; padding: 5px; background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; z-index: 1000;">
            Click the Up or Down Arrow to go to the previous or next target spreadsheet, or use the scroll bar to find and select a spreadsheet.
          </div>
        </div>

        <!-- Gray Bar (No Resize Handle) -->
        <div class="gray-bar"
             [style.top.px]="0"
             [style.left.px]="bundle.gridX + bundle.gridW - 2"
             [style.height.px]="bundle.objH - 30"
             style="position: absolute;"
             ></div>

        <!-- Target Value Instructions -->
        <div [style.top.px]="0"
             [style.left.px]="bundle.gridX + bundle.gridW + 10"
             [style.width.px]="bundle.targetGridWidth"
             style="position: absolute; white-space: normal;">

          <div class="txtBold_16" style="float: left; padding-top: 0px; white-space: normal;">
            Target Values:
          </div>

          <!--Tooltip_03-->
          <div style="float: left; padding-left: 0px;">
            <img height="10"
                 style="float: left; padding-left: 0px; padding-top: -5px; width: auto; cursor: pointer; "
                 src="assets/infoBtn.png"
                 (mouseenter)="showTooltip_03 = true"
                 (mouseleave)="showTooltip_03 = false">

            <div *ngIf="showTooltip_03"
                 [style.left.px]="bundle.gridX + 150"
                 style="position: absolute; top: 0; width: 200px; padding: 5px; background-color: #f9f9f9; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; z-index: 1000;">
              Below are the values in the active form where entry is required.   Only spreadsheets added to the active form are available in this drag-and-drop application.  Click on and drag-drop the target value in a spreadsheet in the Target Value’s ‘Result’ cell below.  This action ‘maps’ the location of the Target Value in standard/same report spreadsheets.  This map will be applied to future spreadsheets that it recognizes to automatically enter Target Values into their ‘Result’ cells.  Select ‘Remove’ in a Target Value row to remove that value’s result and map.
            </div>

          </div>

          <div class="txtSmall_11" style="clear:left; padding-top: 5px; white-space: normal;">
            Click and drag values from spreadsheet to the target value 'Result' cell:
          </div>

        </div>

        

      </div>

    </div>


</ng-template>

</div>
